<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="color">mdi-smoke-detector</v-icon>
      </template>
      <template #value>{{ smokeState }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <SmokeHistoryDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" @setting="showSettingsDialog"></SmokeHistoryDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import SmokeHistoryDialog from '@/components/history/SmokeHistoryDialog'

export default {
  name: 'SmokeTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    SmokeHistoryDialog
  },
  computed: {
    smokeState() {
      return this.report.smokeState ? this.$t(`smoke.${this.report.smokeState}`) : '---';
    },
    color() {
      switch (this.report.smokeState) {
        case 'ALARM':
          return 'red';
        default:
          return 'grey';
      }
    }
  }
}
</script>
